import { styled } from '@linaria/react';
import { colors, fonts, space } from '../../theme/tokens';

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${space[4]};
  padding: ${space[4]};
  background: ${colors.lighterGrey};
  border-radius: 12px;
`;

export const Label = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.medium};
  color: ${colors.fontPrimary};
  flex: 1;
  min-width: 0;
`;
